import { jwtDecode } from "jwt-decode";
import { User } from "oidc-client-ts";

import { getMockPerms } from "./localStorageUtils";
import { isTech } from "./miscUtils";

export const isRoutePermitted = (
	userPerms = {},
	pagePerms,
	isSysAdmin = false
) => {
	if (!pagePerms) return true;

	if (isSysAdmin) {
		const mockPerms = getMockPerms();
		if (mockPerms) {
			userPerms = getMockPerms();
			isSysAdmin = false;
		}
	}

	for (const perm in pagePerms) {
		if (perm === "org") {
			let hasOrgPerm = false;

			for (const orgPerm in pagePerms[perm]) {
				if (userPerms[orgPerm] === pagePerms[perm][orgPerm]) {
					hasOrgPerm = true;
					break;
				}
			}

			if (!hasOrgPerm) return false;
		}

		if (userPerms[perm] === pagePerms[perm] || isSysAdmin) {
			return true;
		}
	}
	return false;
};

export const getIsSysAdmin = () => {
	if (import.meta.env.VITE_MOCK_MODE === "true") return true;

	const oidcStorage = sessionStorage.getItem(
		`oidc.user:${
			isTech
				? import.meta.env.VITE_STS_AUTHORITY_TECH
				: import.meta.env.VITE_STS_AUTHORITY
		}:${import.meta.env.VITE_CLIENT_ID}`
	);
	if (!oidcStorage) {
		return false;
	}
	const user = User.fromStorageString(oidcStorage);
	const authToken = user?.access_token;
	let isSysAdmin = false;
	if (authToken) {
		const jwt = jwtDecode(authToken);
		if (typeof jwt.role === "string") {
			isSysAdmin = jwt.role === "sysadmin";
		} else if (Array.isArray(jwt.role)) {
			isSysAdmin = !!jwt.role.find((r) => r === "sysadmin");
		}
	}

	return isSysAdmin;
};
